export { default } from "./RolesPage";



// WEBPACK FOOTER //
// ./src/screens/Roles/index.ts